export const Text1 =
  "Our professionals are trained on the right technique to wash their hands. We recommend that you allow the professional to use the washroom to wash their hands before and after your home service.";
export const Text2 =
  "Our professionals are mandated to wear face masks while performing their service.";
export const Text3 =
  "Our professionals are encouraged to disinfect their work area after performing their task.";
export const Text4 =
  "Our professionals are encouraged to follow social distancing norms and maintain low-contact.";
